module.exports = __webpack_public_path__ + "static/media/center_empty.a02a85e8.svg";